import { Box, Button, CircularProgress, Divider, FormControlLabel, Menu, MenuItem, Radio, RadioGroup, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Page from '../../component/Page'
import api from '../../api/api'
import { useSelector } from 'react-redux'
import dayjs from 'dayjs'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faPrint, faSave } from '@fortawesome/free-solid-svg-icons'
import Swal from 'sweetalert2'
export default function ReceiptDetail() {
    const { id } = useParams()
    const [data, setData] = useState([])
    const [PaymentType, setPaymentType] = useState(null)
    const [loadingDownload, setLoadingDownload] = useState(false)
    const { profile, loading } = useSelector(state => state.profile)
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const navigate = useNavigate();

    async function getDoiDetail() {
        const newDoi = encodeURIComponent(id);
        const url = 'sale/receipts' + `/${newDoi}`;
        const res = await api.get(url)
        const data = await res.data.result
        if (res.data.status === true) {
            setData(data)
        }
    }

    useEffect(() => {
        getDoiDetail()
    }, [])




    async function downloadFileReceipt(mode) {
        setLoadingDownload(true)
        const newDoi = encodeURIComponent(id);
        const res = await api.get(`sale/receipts/${newDoi}/pdf${mode ? `?mode=${mode}` : ''}`, {
            responseType: 'arraybuffer'
        })
        const data = res.data

        const blob = new Blob([data], { type: 'application/pdf' });
        // saveAs(blob, file?.FileName);
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');
        setLoadingDownload(false)
    }
    async function CancelDoi() {
        Swal.fire({
            title: 'ยืนยันการยกเลิก',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#4ab866',
            cancelButtonColor: '#d33',
        }).then((result) => {
            if (result.isConfirmed) {
                const convertDoiNo = encodeURIComponent(id)
                const url = 'sale/receipts' + `/${convertDoiNo}/cancel`

                const Cancel = async () => {
                    const res = await api.put(url, null)
                    const data = res.data
                    if (data.status === true) {
                        getDoiDetail()
                        Swal.fire(
                            'Good job!',
                            'ยกเลิกเรียบร้อย',
                            'success'
                        )
                    }
                }
                Cancel()

            }

        })
        // this.loading.cancalLoading = false;
    }
    return (
        <div style={{ padding: '10px 30px' }}>
            <Page><div class="container-fluid" >
                <div class="d-flex row align-items-center ">
                    <div class="col-6">
                        <label class="title-content mt-4 mb-4">
                            ข้อมูลใบเสร็จ
                        </label>
                        {data?.Status === 'N' &&
                            <label style={{
                                fontSize: '1.5rem',
                                marginLeft: '20px',
                                color: 'red'
                            }}>
                                **ยกเลิก
                            </label>}
                    </div>
                    <div class="col-6 text-end px-4">
                        {data?.Status === 'Y' &&
                            <>
                                <Button
                                    sx={{ width: '150px' }}
                                    startIcon={<FontAwesomeIcon icon={faPrint} />}
                                    aria-controls={open ? 'basic-menu' : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={open ? 'true' : undefined}
                                    disabled={loadingDownload ? true : false}
                                    onClick={handleClick} variant='outlined'>{loadingDownload ? <CircularProgress size={'18px'} color="inherit" /> : 'ดาวน์โหลด'}</Button>
                                <Menu
                                    id="basic-menu"
                                    anchorEl={anchorEl}
                                    open={open}
                                    onClose={handleClose}
                                    MenuListProps={{
                                        'aria-labelledby': 'basic-button',
                                    }}
                                >
                                    {data &&
                                        <>
                                            <MenuItem onClick={() => {
                                                downloadFileReceipt()
                                                handleClose()
                                            }}>ดาวน์โหลดใบเสร็จ</MenuItem>
                                            <MenuItem onClick={() => {
                                                downloadFileReceipt(1)
                                                handleClose()
                                            }}>ดาวน์โหลดใบเสร็จ(ตัวจริง)</MenuItem>
                                            <MenuItem onClick={() => {
                                                downloadFileReceipt(2)
                                                handleClose()
                                            }}>ดาวน์โหลดใบเสร็จ(สำเนา)</MenuItem>
                                        </>
                                    }
                                </Menu>
                            </>
                        }

                        {data.Status === 'Y' && profile?.BranchNo?.BranchNo === '00' && <Button onClick={CancelDoi} variant='outlined' color='error' sx={{ marginLeft: '20px' }}>ยกเลิก</Button>}
                    </div>

                </div>


                <div class="row">
                    <div class="col-lg-4 col-md-6">
                        <label class="labelInput me-3">ผู้สร้าง</label> <label class="message-error-label">
                            {/* ( {saleDois?.CreateDate | date:'dd/MM/yyyy'} ) */}
                            ( {dayjs(data?.CreateDate).format('DD/MM/YYYY')} )

                        </label>

                        <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                            <TextField disabled value={data?.CreateId} variant="standard" fullWidth
                                InputProps={{
                                    disableUnderline: true,
                                    readOnly: true
                                }}
                            />
                        </Box>
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <label class="labelInput me-3">ผู้แก้ไข</label> <label class="message-error-label">
                            {/* ( {{saleDois?.ModifiedDate | date:'dd/MM/yyyy'}} ) */}
                            ( {dayjs(data?.ModifiedDate).format('DD/MM/YYYY')} )
                        </label>

                        <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                            <TextField disabled value={data?.ModifiedId} variant="standard" fullWidth
                                InputProps={{
                                    disableUnderline: true,
                                    readOnly: true
                                }}
                            />
                        </Box>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-4 col-md-12">
                        <label class="labelInput">เลขที่ใบเสร็จ</label>

                        <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                            <TextField value={data?.ReceiptNo} variant="standard" fullWidth
                                InputProps={{
                                    disableUnderline: true,
                                    readOnly: true
                                }}
                            />
                        </Box>
                    </div>

                    <div class="col-lg-4 col-md-12">
                        <label class="labelInput">ศูนย์เมล็ดพันธุ์ข้าว</label>

                        <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                            <TextField value={data?.BranchName} variant="standard" fullWidth
                                InputProps={{
                                    disableUnderline: true,
                                    readOnly: true
                                }}
                            />
                        </Box>
                    </div>
                    <div class="col-lg-4 col-md-12">
                        <label class="labelInput">วันที่</label>

                        <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                            <TextField value={dayjs(data?.DocumentDate).format('DD/MM/BBBB')} variant="standard" fullWidth
                                InputProps={{
                                    disableUnderline: true,
                                    readOnly: true
                                }}
                            />
                        </Box>
                    </div>
                    <div class="col-lg-4 col-md-12">
                        <label class="labelInput">ชื่อผู้ซื้อ</label>

                        <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                            <TextField value={data?.CustomerName} variant="standard" fullWidth
                                InputProps={{
                                    disableUnderline: true,
                                    readOnly: true
                                }}
                            />
                        </Box>
                    </div>
                    <div class="col-lg-4 col-md-12">
                        <label class="labelInput">ประเภทผู้ซื้อ</label>

                        <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                            <TextField value={data?.CustomerTypeName} variant="standard" fullWidth
                                InputProps={{
                                    disableUnderline: true,
                                    readOnly: true
                                }}
                            />
                        </Box>
                    </div>
                    <div class="col-lg-4 col-md-12">
                        <label class="labelInput">เบอร์โทรศัพท์</label>
                        <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                            <TextField value={data?.Tel} variant="standard" fullWidth
                                InputProps={{
                                    disableUnderline: true,
                                    readOnly: true
                                }}
                            />
                        </Box>
                    </div>

                    <div class="col-md-12">
                        <label class="labelInput">ที่อยู่</label>

                        <Box className='backgroundField' sx={{ marginBottom: '20px', borderRadius: '25px' }}>
                            <TextField value={`${data?.HouseNumber ? 'บ้านเลขที่' + data?.HouseNumber : ''} ${data?.Moo ? 'หมู่ ' + data?.Moo : ''} ${data?.Address ? 'ถนน' + data?.Address : ''} ${data?.SubDistrict ? 'ตำบล' + data?.SubDistrict : ''} ${data?.District ? 'อำเภอ' + data?.District : ''} ${data?.Province ? 'จังหวัด' + data?.Province : ''} ${data?.Zipcode}`} variant="standard" fullWidth multiline rows={4}
                                InputProps={{
                                    disableUnderline: true,
                                    readOnly: true
                                }}
                            />
                        </Box>

                    </div>
                    <div class="col-lg-4 col-md-12">
                        <label class="labelInput">จำนวนเงิน</label>


                        <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                            <TextField value={parseFloat(data?.TotalAmount).toFixed(2)
                                .replace(/\d(?=(\d{3})+\.)/g, "$&,") + ' บาท'}
                                variant="standard" fullWidth
                                InputProps={{
                                    disableUnderline: true,
                                    readOnly: true
                                }}
                            />
                        </Box>
                    </div>
                </div>

                <div class="row mt-4">
                    <div class="col-12 ">
                        <Button onClick={() => navigate(-1)} variant='outlined'
                            startIcon={<FontAwesomeIcon icon={faArrowLeft} />}
                            sx={{ width: '130px', fontSize: '14px', marginRight: '10px' }}>กลับ</Button>
                    </div>
                </div>
            </div>
            </Page>
        </div>
    )
}
